import { render, staticRenderFns } from "./PeriodStats.vue?vue&type=template&id=79904162&scoped=true&"
import script from "./PeriodStats.vue?vue&type=script&lang=js&"
export * from "./PeriodStats.vue?vue&type=script&lang=js&"
import style0 from "./PeriodStats.vue?vue&type=style&index=0&id=79904162&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79904162",
  null
  
)

export default component.exports